import React from 'react';
import { useLocation } from 'react-router-dom';
import SimpleReportForm from '../SimpleReportForm';
import GenericSurepassOutputComponent from '../output/GenericSurepassOutputComponent';

const SmsSubmitOtpInputComponent = () => {
    // When navigated here from the Send page's "Verify OTP now →" button,
    // the client_id arrives via react-router location state. Pre-fill the
    // Client ID field so the user only types the 6-digit OTP. Falls back
    // to empty if landed here directly (sidebar click / manual URL).
    const location = useLocation();
    const prefillClientId = location.state?.prefillClientId || '';

    return (
        <SimpleReportForm
            banner={{ icon: 'pi-check-circle', title: 'SMS Submit OTP', subtitle: 'Verify a one-time password against an SMS request' }}
            fields={[
                { name: 'clientId', label: 'Client ID', icon: 'pi-key', placeholder: 'sms_xxxxxxxxxxxxx', maxLength: 100, mono: true },
                { name: 'otp', label: 'OTP', icon: 'pi-lock', placeholder: '6-digit OTP', maxLength: 6, inputMode: 'numeric', numeric: true, autoComplete: 'one-time-code', mono: true,
                  regex: /^\d{4,8}$/, regexError: 'Enter a valid OTP', colClass: 'col-12 md:col-4' },
            ]}
            // Forward the client_id from the previous page when present.
            initialValues={{ clientId: prefillClientId }}
            endpoint={{
                path: '/surepass/sms/submit-otp',
                bodyMapper: (v, sid) => ({ client_id: v.clientId.trim(), otp: v.otp, api_provider_service_id: parseInt(sid, 10) }),
            }}
            consentReportType="sms-submit-otp"
            submitLabel="Verify OTP"
            successSummary="OTP verified"
            errorSummary="OTP verification failed"
            confirmHeader="Confirm OTP verification"
            confirmAcceptLabel="Yes, verify"
            outputComponent={GenericSurepassOutputComponent}
            outputProps={{ title: 'OTP Verified', icon: 'pi-check-circle' }}
        />
    );
};

export default SmsSubmitOtpInputComponent;
